var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoweIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.794,
    height: 18.272,
    viewBox: "0 0 19.794 18.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9,0,0,2.284V3.807L9.9,1.523l9.9,2.284V2.284ZM5.329,4.568a14.453,14.453,0,0,0-4.853,1L0,5.781V17.51H8.589a1.505,1.505,0,0,0,2.617,0h8.589V5.781l-.476-.214a14.453,14.453,0,0,0-4.853-1,13.167,13.167,0,0,0-4.568.9A13.167,13.167,0,0,0,5.329,4.568Zm0,1.523a12.655,12.655,0,0,1,3.807.738V15.3a12.335,12.335,0,0,0-3.807-.666,11.953,11.953,0,0,0-3.807.666V6.828A11.7,11.7,0,0,1,5.329,6.091Zm9.136,0a11.7,11.7,0,0,1,3.807.738V15.3a11.953,11.953,0,0,0-3.807-.666,12.335,12.335,0,0,0-3.807.666V6.828A12.655,12.655,0,0,1,14.465,6.091Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoweIconWhite);
export default __webpack_public_path__ + "static/media/howe-icon-white.763bda3a3acbf23abbd64a785f383eb1.svg";
export { ForwardRef as ReactComponent };